/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

import { isValidSubnetMask } from '../../../../../../utils/validators';

export const validationSchema = Yup.object({
  allowedSourceRanges: Yup.array()
    .of(
      Yup.string()
        .required('empty')
        .test('is valid network mask', 'subnet_mask_not_valid', val => !val || isValidSubnetMask(val)),
    )
    .max(10, 'max_arr_length')
    .test('is unique array', 'unique_arr', val => new Set(val).size === val.length),
});
